/*
 * Generated by orval v3.2.3 🍺
 * Do not edit manually.
 * BFF Providers Api
 * OpenAPI spec version: v1
 */

export type CustomerStatus = 'ACTIVE' | 'FROZEN' | 'BLOCKED' | 'NOT_FOUND';

export const CustomerStatus = {
  ACTIVE: 'ACTIVE' as CustomerStatus,
  FROZEN: 'FROZEN' as CustomerStatus,
  BLOCKED: 'BLOCKED' as CustomerStatus,
  NOT_FOUND: 'NOT_FOUND' as CustomerStatus,
};
